import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';
import * as utils from '../common/Utils.js'
import { useConfig } from '../contexts/ConfigContext.js';
import { useAdminGuard } from '../hooks/useAdminGuard.js';

import { collection, getDocs, getDoc, setDoc, doc } from "firebase/firestore";
import { db } from '../firebase.js';

const AdminPlayers = () => {
  const navigate = useNavigate();
  const config = useConfig();
  const { currentUser, isReady } = useAdminGuard();
  const SEASON = config.currentSeason;
  const { playerID } = useParams();
  const [league, setLeague] = useState({
    games: [],
    gameStats: [],
    players: [],
    seasonTeams: [],
    teams: []
  });
  const [dataReady, setDataReady] = useState(false);
  const [player, setPlayer] = useState({});

  useEffect(() => {
    if (!isReady) return;

    getPlayer();
    getLeague();
  }, [isReady]); // eslint-disable-line react-hooks/exhaustive-deps

  const getPlayer = async () => {
    try {
      const docRef = doc(db, "players", playerID);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setPlayer({ id: docSnap.id, ...docSnap.data() });
      } else {
        setPlayer(null);
      }
    } catch (error) {
      console.error("Error getting player:", error);
    }
  };


  const getLeague = async () => {
    const playersSnapshot = await getDocs(collection(db, 'players'));
    const players = playersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    const seasonTeamsSnapshot = await getDocs(collection(db, 'seasonTeams'));
    const seasonTeams = seasonTeamsSnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(st => st.season == SEASON);

    setLeague(prev => ({ ...prev, players, teams: seasonTeams }));
    setDataReady(true);
  }

  function displayPlayers () {
    let thisSeasonPlayers = []
    for (const team of league.teams) {
      thisSeasonPlayers = thisSeasonPlayers.concat(team.players);
    }

    let playersInCurrentSeason = league.players.filter((player) => thisSeasonPlayers.includes(player.id))
    let playersNotInCurrentSeason = league.players.filter((player) => !thisSeasonPlayers.includes(player.id))

    playersInCurrentSeason.sort((a, b) => a.firstName.localeCompare(b.firstName));
    playersNotInCurrentSeason.sort((a, b) => a.firstName.localeCompare(b.firstName));

    let displayEditPlayersCurrentSeason = playersInCurrentSeason.map((player) => displayPlayer(player))
    let displayEditPlayersNotInCurrentSeason = playersNotInCurrentSeason.map((player) => displayPlayer(player))

    return (
      <>
        <p>In Season {SEASON}</p>
        { displayEditPlayersCurrentSeason }
        <p>Previous Seasons</p>
        { displayEditPlayersNotInCurrentSeason }
      </>
    )
  }

  function displayPlayer (plyr) {
    return (
      <div className="league-game" key={plyr.id + '-name'}>
        <div className='league-game-info'>
          <p className="league-title-skinny-small" key={plyr.id + "-name"}>{ utils.displayPlayerName(plyr) }</p>
        </div>
        { plyr.imageURL ? <img className="league-player-image-mini" src={ plyr.imageURL }></img> : '' }
        <div className='league-game-edit-button'>
          <a type="button" className="btn btn-dark" href={'/admin/players/' + plyr.id}>Edit</a>
        </div>
      </div>
    )
  }

  async function savePlayer () {
    let plyr = {
      birthday: {
        day: document.getElementById('inputPlayerBirthdayDay').value,
        month: document.getElementById('inputPlayerBirthdayMonth').value,
        year: document.getElementById('inputPlayerBirthdayYear').value
      },
      email: document.getElementById('inputPlayerEmail').value,
      first_name: document.getElementById('inputPlayerFirstName').value,
      height: {
        feet: document.getElementById('inputPlayerHeightFeet').value,
        inches: document.getElementById('inputPlayerHeightInches').value
      },
      image_url: document.getElementById('inputImageUrl').value,
      jersey_number: document.getElementById('inputPlayerJerseyNumber').value,
      jersey_size: document.getElementById('inputPlayerJerseySize').value,
      last_name: document.getElementById('inputPlayerLastName').value,
      phone: document.getElementById('inputPlayerPhone').value,
      player_id: document.getElementById('inputPlayerID').value
    }

    const updatedPlayer = player;

    updatedPlayer.email = plyr.email.toString()
    updatedPlayer.firstName = plyr.first_name.toString()
    updatedPlayer.height.feet = plyr.height.feet.toString()
    updatedPlayer.height.inches = plyr.height.inches.toString()
    updatedPlayer.imageURL = plyr.image_url.toString()
    updatedPlayer.jerseyNumber = plyr.jersey_number.toString()
    updatedPlayer.jerseySize = plyr.jersey_size.toString()
    updatedPlayer.lastName = plyr.last_name.toString()
    updatedPlayer.phone = plyr.phone.toString()

    // Eventually we won't need this...
    if (plyr.birthday.year < 2007) {
      updatedPlayer.birthday = {
        day: plyr.birthday.day.toString(),
        month: plyr.birthday.month.toString(),
        year: plyr.birthday.year.toString()
      }
    }

    // Don't allow player ID to ever be updated...
    // updatedPlayer.player_id = plyr.player_id


    // update playerView
    await setDoc(doc(db, "playerViews", playerID), {
      email: updatedPlayer.email,
      firstName: updatedPlayer.firstName,
      imageURL: updatedPlayer.imageURL,
      lastName: updatedPlayer.lastName
    }, { merge: true });

    // update player
    await setDoc(doc(db, "players", playerID), {
      birthday: {
        day: updatedPlayer.birthday.day,
        month: updatedPlayer.birthday.month,
        year: updatedPlayer.birthday.year
      },
      firstName: updatedPlayer.firstName,
      height: {
        feet: updatedPlayer.height.feet,
        inches: updatedPlayer.height.inches
      },
      imageURL: updatedPlayer.imageURL,
      jerseyNumber: updatedPlayer.jerseyNumber,
      jerseySize: updatedPlayer.jerseySize,
      lastName: updatedPlayer.lastName,
      phone: updatedPlayer.phone
    }, { merge: true })

    // saveLeague();

    navigate(`/players/${playerID}`)
  }


  function yearSelectors () {
    let selectors = []
    for (let year = 2010; year > 1950; year--) {
      selectors.push(<option key={year} value={ year.toString() }>{year}</option>)
    }

    return (
      <>
        { selectors }
      </>
    )
  }

  function displayEditPlayer () {
    if (!player.birthday) {
      player.birthday = {}
      player.birthday.month = ''
      player.birthday.day = ''
      player.birthday.year = ''
    }

    return (
      <>
        <form>
          <div className="form-row">
            <div className="form-group">
              <label for="inputPlayerFirstName">First Name</label>
              <input type="text" className="form-control" id="inputPlayerFirstName" defaultValue={ player.firstName } required></input>
            </div>
            <div className="form-group">
              <label for="inputPlayerLastName">Last Name</label>
              <input type="text" className="form-control" id="inputPlayerLastName" defaultValue={ player.lastName } required></input>
            </div>
          </div>
          <div className="form-group">
            <label for="inputPlayerEmail">Email</label>
            <input type="email" className="form-control" id="inputPlayerEmail" defaultValue={ player.email } required></input>
          </div>
          <div className="form-group">
            <label for="inputPlayerPhone">Phone Number</label>
            <input type="tel" className="form-control" id="inputPlayerPhone" defaultValue={ player.phone } required></input>
          </div>
          <div className="form-group">
            <label for="inputImageUrl">Image URL</label>
            { player.imageURL ? <img className="league-player-image-mini" src={ player.imageURL }></img> : '' }
            <input type="url" className="form-control" id="inputImageUrl" defaultValue={ player.imageURL } required></input>
          </div>
          <label for="inputPlayerHeight">Height</label>
          <div className="form-row">
            <div className="form-group">
              <label for="inputPlayerHeightFeet">Feet</label>
              <select className="form-control" id="inputPlayerHeightFeet" defaultValue={ player.height.feet }>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </div>
            <div className="form-group">
              <label for="inputPlayerHeightInches">Inches</label>
              <select className="form-control" id="inputPlayerHeightInches" defaultValue={ player.height.inches }>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
              </select>
            </div>
          </div>
          <label for="inputBirthday">Birthday</label>
          <div className="form-row">
            <div className="form-group">
              <label for="inputPlayerBirthdayMonth">Month</label>
              <select className="form-control" id="inputPlayerBirthdayMonth" defaultValue={ player.birthday.month }>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
              </select>
            </div>
            <div className="form-group">
              <label for="inputPlayerBirthdayDay">Day</label>
              <select className="form-control" id="inputPlayerBirthdayDay" defaultValue={ player.birthday.day }>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
              </select>
            </div>
            <div className="form-group">
              <label for="inputPlayerBirthdayYear">Year</label>
              <select className="form-control" id="inputPlayerBirthdayYear" defaultValue={ player.birthday.year }>
                { yearSelectors() }
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label for="inputPlayerJerseyNumber">Jersey Number</label>
              <input type="number" className="form-control" id="inputPlayerJerseyNumber" defaultValue={ player.jerseyNumber } required></input>
            </div>
            <div className="form-group">
              <label for="inputPlayerJerseySize">Jersey Size</label>
              <select className="form-control" id="inputPlayerJerseySize" defaultValue={ player.jerseySize }>
                <option value="S">S</option>
                <option value="M">M</option>
                <option value="L">L</option>
                <option value="XL">XL</option>
                <option value="XXL">XXL</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label for="inputPlayerID">Player ID</label>
            <input type="text" className="form-control" id="inputPlayerID" defaultValue={ player.id } required disabled={ playerID ? 'true' : 'false' }></input>
          </div>
          <button className="btn btn-dark" type="button" onClick={savePlayer}>Save Player</button>
        </form>
      </>
    )
  }

  if (dataReady == false || currentUser == null) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Schedule">
        <div className="league-content">

          <div className="league-body">
            <p className='league-admin-back-button'><a className='league-link' href="/admin"><b>← Back to Admin Home</b></a></p>
            { playerID ? <p className='league-admin-back-button'><a className='league-link' href="/admin/players"><b>← Back to Admin &gt; Players</b></a></p> : '' }

            <p className="league-title-standard-secondary text-align-center">Edit Players</p>
            <div className="dropdown league-dropdown">
            </div>
            <div className="league-table-container schedule">
              {
                playerID ?
                displayEditPlayer()
                :
                displayPlayers()
              }
            </div>
          </div>

        </div>

        <Footer/>
      </div>
    );
  }
}

export default AdminPlayers;
